<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span><span class="el-icon-data-board"></span> 概览</span>
        </div>
        <div class="content">
            <el-row :gutter="20">
                <el-col :sm="12" :md="6">
                    <div class="title">
                        演出销售总额
                        <router-link class="color-theme" :to="`/report/sales/show?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                    </div>
                    <div class="num">{{data && data.asAmount || 0}}</div>
                    <div class="ratio">环比: 
                        <span v-if="data && data.asAmountRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{data && data.asAmountRingRatio.value || '0%'}}</span>
                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{data && data.asAmountRingRatio.value || '0%'}}</span>
                    </div>
                </el-col>
                <el-col :sm="12" :md="6">
                    <div class="title">
                        演出订单总数
                        <router-link class="color-theme" :to="`/report/sales/show?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                    </div>
                    <div class="num">{{data && data.asOrderNum || 0}}</div>
                    <div class="ratio">环比:
                        <span v-if="data && data.asOrderNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{data && data.asOrderNumRingRatio.value || '0%'}}</span>
                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{data && data.asOrderNumRingRatio.value || '0%'}}</span>
                    </div>
                </el-col>
                <el-col :sm="12" :md="6">
                    <div class="title">
                        乐迷总数
                        <router-link class="color-theme" :to="`/report/fans/newFans?rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                    </div>
                    <div class="num">{{data && data.fansTotalNum || 0}}</div>
                    <div class="ratio">环比: 
                        <span v-if="data && data.fansTotalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{data && data.fansTotalNumRingRatio.value || '0%'}}</span>
                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{data && data.fansTotalNumRingRatio.value || '0%'}}</span>
                    </div>
                </el-col>
                <el-col :sm="12" :md="6">
                    <div class="title">B类用户总数</div>
                    <div class="num">{{data && data.buserTotalNum || 0}}</div>
                    <div class="ratio">环比: 
                        <span v-if="data && data.buserTotalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{data && data.buserTotalNumRingRatio.value || '0%'}}</span>
                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{data && data.buserTotalNumRingRatio.value || '0%'}}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            data: null,
            dataLoading: false
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/overview",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    .num{
        font-size: 24px;
        margin: 10px 0;
    }
    // .ratio{
    //     margin: 10px 0;
    // }
    .title{
        color: $--color-info;
    }
}
</style>